import { createColumn } from "@/lib/table/columnFactory";
import type { DemandeAbsenceRow } from "./factory";

export const selectColumn = createColumn<DemandeAbsenceRow>({
  id: "select",
  header: ({ table }) => (
    <input
      type="checkbox"
      aria-label="Sélectionner toutes les demandes de la page"
      checked={table.getIsAllPageRowsSelected()}
      onChange={table.getToggleAllPageRowsSelectedHandler()}
      className="checkbox checkbox-sm"
    />
  ),
  cell: ({ row }) => (
    <input
      type="checkbox"
      aria-label="Sélectionner la demande"
      checked={row.getIsSelected()}
      onChange={row.getToggleSelectedHandler()}
      className="checkbox checkbox-sm"
    />
  ),
  enableHiding: false,
  enableSorting: false,
});
